/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrEventEntity } from '../../models/dbr-event-entity';
import { DbrIdResultClass } from '../../models/dbr-id-result-class';

export interface EventsControllerCreate$Params {
      body: DbrEventEntity
}

export function eventsControllerCreate(http: HttpClient, rootUrl: string, params: EventsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrIdResultClass>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrIdResultClass>;
    })
  );
}

eventsControllerCreate.PATH = '/events';
